module.exports = __webpack_public_path__ + "static/media/boba-fett.0cb50051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/boba-fett.jpg
// module id = 41
// module chunks = 0